import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handlePost } from '../../../utils/AxiosUtil';
import { NumberCell, DateCell } from '../../../utils/Cells';
import * as util from '../../../utils/Util';
import * as enums from '../../../utils/EnumMapping';

class Group extends Component {
    state = {
        payables: [],
        transactions: [],
        selectedTransactions: [],
        proposedPayables: [],
        checkedItems: new Map(),
        billtype: '',
        selected: [],
        selectedItems: new Map(),
        payable: {
            name: '',
            id: '',
            paymentDeadline: '',
            amount: null
        }
    };

    handleSuccess = (res) => {
        console.log(this.props);
        this.props.refresh();
        this.props.close();
    }

    componentDidMount() {
        console.log(this.props);
        this.setState({ billtype: this.props.billtype })
        const payable = this.getPayable();
        console.log(payable);
        this.setState({ payable: payable })
        this.callExpandApi()
            .then(res => this.setState({ transactions: res.data.transactions, proposedPayables: res.data.payables }))
            .catch(err => console.log(err));
    }

    getPayable = () => {
        switch (this.props.row.rowType) {
            case 'SALARY':
                return {
                    name: this.props.row.employeeName,
                    id: this.props.row.year + "." + this.props.row.month + " fizetés",
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.netSalary
                }
            case 'TAX':
                return {
                    name: this.props.row.taxTypeName,
                    id: this.props.row.publicId,
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'INCOMING_BILL':
                return {
                    name: this.props.row.customerName,
                    id: this.props.row.billNumber,
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'OUTGOING_BILL':
                return {
                    name: this.props.row.customerName,
                    id: this.props.row.publicId,
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'RESTRAIN':
                return {
                    name: this.props.row.restrainPartnerName,
                    id: this.props.row.employeeName + " letiltás",
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            default:
                return null;

        }
    }

    callExpandApi = async () => {
        const path = '/api/grouppayable/objects';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "type": this.props.row.rowType,
        };
        const response = await axios.post(path, requestObject);
        if (response.status !== 200) throw Error(response.message);
        console.log(response);
        return response;
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        let request = {
            privateId: this.props.row.privateId,
            type: this.props.row.rowType,
            otherPrivateIds: []
        };
        this.state.selectedItems.forEach((value, key, map) => {
            if (value) {
                request.otherPrivateIds.push(key);
            }
        });

        console.log(request);
        const path = '/api/grouppayable';
        handlePost(path, request, this);
    }

    getPayableSumAmount = () => {
        let sum = this.state.payable.amount;
        /* eslint-disable array-callback-return */
        this.state.proposedPayables.map((row) => {
            if (this.isSelected(row.privateId)) {
                sum = sum + row.amount;
            }
        })
        /* eslint-enable array-callback-return */
        return sum;
    }

    getTransactionSumAmount = () => {
        let sum = 0;
        /* eslint-disable array-callback-return */
        this.state.transactions.map((tr) => {
            sum = sum + parseInt(util.trimSpaces(tr.amount));
        })
        this.state.proposedPayables.map((payable) => {
            if (this.isSelected(payable.privateId)) {
                payable.transactions.map((tr) => {
                    sum = sum + parseInt(util.trimSpaces(tr.amount));
                })
            }
        })
        /* eslint-enable array-callback-return */
        return sum;
    }

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            /* eslint-disable array-callback-return */
            const newSelecteds = this.state.proposedTransactions.map((n) => n.privateId);
            /* eslint-enable array-callback-return */
            this.setState({ selected: newSelecteds });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, payable) => {
        this.select(payable);
        if (!this.isSelected(payable.privateId) && payable.groupId) {
            /* eslint-disable array-callback-return */
            this.state.proposedPayables.map((payable2) => {
                if (payable2.privateId !== payable.privateId && payable2.groupId === payable.groupId && !this.isSelected(payable2.privateId)) {
                    console.log(payable2);
                    this.select(payable2);
                }
            });
            /* eslint-enable array-callback-return */
        }
    };

    select = (payable) => {
        let isChecked = !this.isSelected(payable.privateId);
        this.setState(prevState => ({ selectedItems: prevState.selectedItems.set(payable.privateId, isChecked) }));
        let prop = [];
        if (isChecked) {
            if (payable.transactions) {
                /* eslint-disable array-callback-return */
                payable.transactions.map((tr) => {
                    prop.push(tr)
                })
                /* eslint-enable array-callback-return */
            }
        }
        this.setState({ selectedTransactions: prop });
    };

    isSelected = (privateId) => this.state.selectedItems.has(privateId) && this.state.selectedItems.get(privateId);
    selectedSize = () => {
        let size = 0;
        this.state.selectedItems.forEach((value, key, map) => {
            if (value) {
                size = size + 1;
            }
        })
        return size;
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <h3>{enums.getLabel(enums.objectTypes, this.props.row.rowType)}:</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header">
                                <TableCell>Megnevezés</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell>Fizetési határidő</TableCell>
                                <TableCell align="right">Összeg</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="new">
                                <TableCell> {this.state.payable.name}</TableCell>
                                <TableCell>{this.state.payable.id}</TableCell>
                                <TableCell> <DateCell value={this.state.payable.paymentDeadline} /></TableCell>
                                <TableCell align="right"><NumberCell value={this.state.payable.amount} /></TableCell>
                            </TableRow>
                            {
                                /* eslint-disable array-callback-return */
                                this.state.proposedPayables.map((row) => {
                                    if (this.isSelected(row.privateId)) {
                                        return (
                                            <TableRow key={row.privateId} className="newly-added">
                                                <TableCell> {row.customerName}</TableCell>
                                                <TableCell> Megjegyzés</TableCell>
                                                <TableCell> <DateCell value={row.paymentDeadline} /></TableCell>
                                                <TableCell align="right"> <NumberCell value={row.amount} /></TableCell>
                                            </TableRow>
                                        )
                                    }
                                })
                                /* eslint-enable array-callback-return */
                            }
                            <TableRow key="total">
                                <TableCell> {"Összesen"}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right"><NumberCell value={this.getPayableSumAmount()} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <h3>Linkelt tranzakciók:</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header">
                                <TableCell>Dátum</TableCell>
                                <TableCell>Ellenoldal</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell align="right">Linkelt összeg</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.transactions.map((row) => (
                                <TableRow key={row.privateId}>
                                    <TableCell> <DateCell value={row.transaction.transactionDateTime} /></TableCell>
                                    <TableCell> {row.transaction.contraName}</TableCell>
                                    <TableCell>{row.transaction.comment}</TableCell>
                                    <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                </TableRow>
                            ))}
                            {this.state.selectedTransactions.map((tr) => {
                                return (
                                    <TableRow key={tr.transaction.privateId} className="newly-added">
                                        <TableCell> <DateCell value={tr.transaction.transactionDateTime} /></TableCell>
                                        <TableCell> {tr.transaction.contraName}</TableCell>
                                        <TableCell>{tr.transaction.comment}</TableCell>
                                        <TableCell align="right"><NumberCell value={tr.amount} /></TableCell>
                                    </TableRow>
                                )
                            }
                            )}
                            <TableRow key="total">
                                <TableCell> {"Összesen"}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right"><NumberCell value={this.getTransactionSumAmount()} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <h3>Javasolt számlák:</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header">
                                <TableCell padding="checkbox"></TableCell>
                                <TableCell>Megnevezés</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell>Fizetési határidő</TableCell>
                                <TableCell align="right">Összeg</TableCell>
                                <TableCell align="right">Fennmaradó összeg</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.proposedPayables.map((row, index) => {
                                const isItemSelected = this.isSelected(row.privateId);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <TableRow
                                        key={row.privateId}
                                        hover
                                        onClick={(event) => this.handleClick(event, row)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        selected={isItemSelected}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                checked={isItemSelected}
                                                inputProps={{ 'aria-labelledby': labelId }}
                                                color="primary"
                                            />
                                        </TableCell>
                                        <TableCell>{row.customerName}</TableCell>
                                        <TableCell>{row.comment}</TableCell>
                                        <TableCell> <DateCell value={row.paymentDeadline} /></TableCell>
                                        <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                        <TableCell align="right"><NumberCell value={row.remainingAmount} /></TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    };
}

export default withSnackbar(Group);